import React from 'react';
import { Modal, Table, TableColumnsType } from 'antd';
import { formatNumber } from '@/utilities/dataUtils';
import { InvoiceList } from '@/interfaces/seller';

interface IProps {
  open: boolean;
  invoiceList: InvoiceList[];
  onClose: () => void;
}

const PaymentInvoiceModal: React.FC<IProps> = ({
  invoiceList,
  open,
  onClose,
}) => {
  const handleOk = () => {
    onClose();
  };

  const columns: TableColumnsType<InvoiceList> = [
    {
      title: 'ลำดับ',
      dataIndex: '',
      width: 40,
      align: 'center',
      className: 'text-bold',
      render: (_, rec, i) => <div className="font-weight-bold">{i + 1}</div>,
    },
    {
      title: 'ใบตั้งหนี้',
      dataIndex: 'AR_BILL_NBR',
      align: 'center',
      className: 'text-bold',
      width: 120,
    },
    {
      title: 'เอกสาร INVOICE',
      dataIndex: 'AR_NBR',
      align: 'center',
      className: 'text-bold',
      width: 120,
    },
    {
      title: 'ยอดเงิน',
      dataIndex: 'AR_AMT',
      align: 'right',
      className: 'text-bold',
      width: 120,
      render: (_) => formatNumber(_, 2),
    },
  ];

  return (
    <Modal
      title="รายการ"
      open={open}
      onCancel={handleOk}
      footer={false}
      // onCancel={handleCancel}
      width={1000}
    >
      <Table<InvoiceList>
        columns={columns}
        dataSource={invoiceList}
        size="small"
        bordered
        rowKey={'BILL_NBR'}
        pagination={false}
        locale={{
          emptyText: 'ไม่พบรายการ',
        }}
      />
    </Modal>
  );
};

export default PaymentInvoiceModal;
